import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import screenfull from "screenfull";
import "./styles.css";
import "components/screenshot/screenshot.css";
import QualitySelector from "../QualitySelector";

const HINT_DURATION = 5000;

const VideoControls = ({
  onScreenshot,
  onReportCart,
  qualities,
  selectedQuality,
  onSelectQuality,
  connectionSpeed,
  showCaptureHint,
  onDismissHint
}) => {
  const cartBtnRef = useRef(null);
  const [hintStyle, setHintStyle] = useState({});
  const [hintLeaving, setHintLeaving] = useState(false);

  useEffect(() => {
    if (showCaptureHint && cartBtnRef.current) {
      const rect = cartBtnRef.current.getBoundingClientRect();
      setHintStyle({
        position: "fixed",
        bottom: window.innerHeight - rect.top + 10,
        left: Math.max(8, rect.left + rect.width / 2 - 128),
        top: "auto",
        right: "auto"
      });
      setHintLeaving(false);
    }
  }, [showCaptureHint]);

  const handleDismiss = () => {
    setHintLeaving(true);
    setTimeout(() => {
      onDismissHint?.();
      setHintLeaving(false);
    }, 260);
  };

  const toggleFullscreen = () => {
    if (screenfull.isEnabled) {
      screenfull.toggle(document.querySelector(".video-player-wrapper"));
    }
  };

  return (
    <div className={`video-controls${showCaptureHint ? " video-controls--hint" : ""}`}>
      <div className="controls-left">
        <QualitySelector
          qualities={qualities}
          selectedQuality={selectedQuality}
          onSelectQuality={onSelectQuality}
          connectionSpeed={connectionSpeed}
        />
      </div>

      <div className="controls-center">
        <button
          className="control-button"
          onClick={onScreenshot}
          aria-label="Take screenshot"
        >
          <i className="fas fa-camera" />
        </button>

        <button
          ref={cartBtnRef}
          className={`control-button report-cart-btn${showCaptureHint ? " report-cart-btn--pulse" : ""}`}
          onClick={onReportCart}
          aria-label="Open reports"
        >
          <i className="fas fa-clipboard-list" />
        </button>
      </div>

      <div className="controls-right">
        <button
          className="control-button"
          onClick={toggleFullscreen}
          aria-label="Toggle fullscreen"
        >
          <i className="fas fa-expand" />
        </button>
      </div>

      {showCaptureHint && createPortal(
        <div
          className={`capture-hint capture-hint--arrow-bottom${hintLeaving ? " capture-hint--leaving" : ""}`}
          style={{ ...hintStyle, "--hint-duration": `${HINT_DURATION}ms` }}
          onClick={handleDismiss}
          role="status"
          aria-live="polite"
        >
          <div className="capture-hint__body">
            <div className="capture-hint__check">
              <i className="fas fa-check" />
            </div>
            <div className="capture-hint__text">
              <span className="capture-hint__title">Captura registrada</span>
              <span className="capture-hint__sub">
                Clique em <i className="fas fa-clipboard-list" /> para revisar e salvar
              </span>
            </div>
            <div className="capture-hint__arrow">
              <i className="fas fa-chevron-right" />
            </div>
          </div>
          <div className="capture-hint__timer">
            <div className="capture-hint__timer-fill" />
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default VideoControls;
